import {DefaultEventProps, DefaultInformationProps} from "@models/DefaultProps.ts";
import {ISolicitacaoQuickFix} from "@models/solicitacoes/ISolicitacaoQuickFix.ts";
import {Grid, IconButton, Typography} from "@mui/material";
import {_SolicitacoesEndpoints} from "@localization/siteMap/endpoints/_SolicitacoesEnpoints";
import {ThumbDown, ThumbUp} from "@mui/icons-material";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {useApi} from "@contexts/hooks/api/useApi.ts";

export interface SolicitacaoQuickFixInfo extends DefaultInformationProps<ISolicitacaoQuickFix>, Pick<DefaultEventProps<ISolicitacaoQuickFix>, 'onUpdate'> {
}

export function SolicitacaoQuickFixInfo(props: SolicitacaoQuickFixInfo) {
    const {value} = props;

    return (
        <>
            <div>
                <strong>Tipo:</strong> {value.quickFixType}
            </div>
            <div>
                <strong>Solicitante:</strong> {value.solicitante?.nome}
            </div>
            <div>
                <strong>Data Solicitação:</strong> {value.dataSolicitacao.format('DD/MM/YYYY HH:mm')}
            </div>
            <div>
                <strong>Status:</strong> {value.status}
            </div>
        </>
    );
}

export function SolicitacaoQuickFixInfoList(props: Omit<SolicitacaoQuickFixInfo, 'variant'>) {
    const {value} = props;
    const {Get} = useApi();
    const {closePopUp, createAlertFromResponse} = useAlert();

    return (
        <Grid container spacing={1}>
            <Grid><Typography>{value.id}</Typography></Grid>
            <Grid><Typography>{value.status}</Typography></Grid>
           {/* <Grid><Typography component={'span'}><UsuarioTypo typographyProps={{component: 'span'}}
                                                              usuarioId={value.solicitanteId}/> Solicitou que troque
                o campo "{value.quickFixType}" para "{value.toValue}"</Typography></Grid>*/}
            <IconButton disabled={value.status != 'Pendente'} onClick={() => {

                Get(_SolicitacoesEndpoints.ApproveQuickFix({quickFixId: value.id})).then(x => {
                    if (x.status === 'Success') {
                        closePopUp()
                        // setQuickFixes(quickFixes.filter(qf => qf.id !== x.items.id));
                        if (props.onUpdate) {
                            props.onUpdate(x.items);
                        }
                    }
                    createAlertFromResponse(x)
                })
            }}>
                <ThumbUp color={value.status == 'Pendente' ? 'success' : 'inherit'}/>
            </IconButton>
            <IconButton disabled={value.status != 'Pendente'} onClick={() => {

                Get(_SolicitacoesEndpoints.RejectQuickFix({quickFixId: value.id})).then(x => {
                    if (x.status === 'Success') {
                        closePopUp()
                        // setQuickFixes(quickFixes.filter(qf => qf.id !== x.items.id));
                        if (props.onUpdate) {
                            props.onUpdate(x.items);
                        }
                    }
                    createAlertFromResponse(x)

                })
            }}>
                <ThumbDown color={value.status == 'Pendente' ? 'error' : 'inherit'}/>
            </IconButton>
        </Grid>
    );
}